import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more.svg';
import { ReactComponent as CloseImg } from '../../../img/ico-prefix-close.svg';
import { useTranslation } from "react-i18next";
import { CustomSquareCheckBox } from "../../base/CustomCheckBox";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { PodProfileVolumeData, podVolumeHostPathTypes, podVolumeTypes } from "./PodProfileData";
import { serviceTypes } from "../service/PodServiceData";
import StepLine from "../../base/tamplate/StepLine";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import { CustomImgBtn } from "../../base/CustomImgBtn";
import CustomText from "components/base/CustomText";

interface ArgsType {
    projectId: string;
    podProfileId: string;
    podProfileName: string;
    pod_profile_volume_id: string;
    pod_profile_volume_name: string;
    pod_profile_volume_type_code: string;
    claim_name: string;
    host_path: string;
    host_path_type_code: string;
}


interface PodProfileVolumeUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

PodProfileVolumeUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function PodProfileVolumeUpdate(props:PodProfileVolumeUpdateProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);


    const [volumeName, setVolumeName] = useState("");
    const [volumeTypeCode, setVolumeTypeCode] = useState("PVC");
    const [hostPathTypeCode, setHostPathTypeCode] = useState("DIR");
    const [hostPath, setHostPath] = useState("");

    const [volumeChangeYn, setVolumeChangeYn] = useState(false);
    const [volumeNameWarnYn, setVolumeNameWarnYn] = useState(false);
    const [volumeHostPathWarnYn, setVolumeHostPathWarnYn] = useState(false);

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);



    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {

            } else {
                if(checkVolumeData()) {
                    setExecuteUpdateYn(true);
                } else {
                    executeResult({successYn: false}, false, '');
                }
            }
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(props.args) {
            setVolumeName(props.args?.pod_profile_volume_name);
            setVolumeTypeCode(props.args?.pod_profile_volume_type_code);
            setHostPath(props.args?.host_path);
            setHostPathTypeCode(props.args?.host_path_type_code);
        }
    }, [props.args]);

    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdatePodProfileVolume();
        }
    }, [executeUpdateYn]);

    useEffect(() => {
        if(volumeChangeYn) {
            setVolumeChangeYn(false);
        }
    }, [volumeChangeYn]);


    function checkVolumeData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }

        setVolumeNameWarnYn(false);
        setVolumeHostPathWarnYn(false);
        let message = "";
        let error = false;


        if(!volumeName) {
            message = t("MESSAGE_POD_PROFILE_VOLUME_INFO_ENTER_ERROR_MESSAGE");
            error = true;
            if(!volumeName) {
                setVolumeNameWarnYn(true);
            }

        }
        if(volumeTypeCode === "HOSTPATH" && !hostPath) {
            message = t("MESSAGE_POD_PROFILE_VOLUME_INFO_ENTER_ERROR_MESSAGE");
            error = true;
            setVolumeHostPathWarnYn(true);
        }

        if(error === true) {
            executeResult({}, false, message);
        }

        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteUpdateYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }



    function executeUpdatePodProfileVolume() {
        const data = {
            remove_yn : false,
            pod_profile_volume_id: props.args?.pod_profile_volume_id,
            pod_profile_volume_name: volumeName,
            pod_profile_volume_type_code: volumeTypeCode,
            host_path: hostPath,
            host_path_type_code: hostPathTypeCode

        }

        const updatePackageData = {
            pod_profile_volumes: [data]
        }

        requests.put(PLATFORM_URL.POD_PROFILE + "/" + props.args?.podProfileId, updatePackageData)
        .then((response) => {
            executeResult({successYn: true }, true, "");
        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }



    return (
            <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("MESSAGE_POD_PROFILE_VOLUME_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    {
                        volumeChangeYn === false ?
                        <View style={style.mainContainer}>
                            <View style={style.rowContainer}>
                                <CustomText text={t("VOLUME_NANE")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomTextInput
                                    key={501}
                                    width={570} height={36}
                                    value={volumeName}
                                    type={"text"}
                                    activeYn={true}
                                    inputCb={(v)=>{setVolumeName(v)}}
                                    warnYn={volumeNameWarnYn}
                                    placeHolderText={t("NAME_ENTER_MESSAGE")}
                                />
                            </View>
                            <Text style={{
                                marginTop: -15, marginLeft: 150, marginBottom: 10,
                                fontFamily: FONT.REGULAR,
                                fontSize: 12,
                                color: "#3a8344",
                            }}>
                                {t("MESSAGE_VOLUME_NAME_MATCHED_VOLUME_MOUNT_NAME_MESSAGE")}
                            </Text>
                            <View style={style.rowContainer}>
                                <CustomText text={t("POD_VOLUME_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomDropDown
                                    key={45}
                                    width={540} height={36}
                                    items={podVolumeTypes}
                                    value={volumeTypeCode}
                                    setValue={(v)=>setVolumeTypeCode(v)}
                                    disable={false}
                                    defaultvalue={podVolumeTypes[0]}
                                />
                            </View>
                            {
                                volumeTypeCode === "HOSTPATH"
                                ? <View style={style.rowContainer}>
                                    <CustomText text={t("POD_VOLUME_HOST_PATH")} fontStyle={style.columnText} asterisk={true}/>
                                    <CustomTextInput
                                        key={502}
                                        width={570} height={36}
                                        value={hostPath}
                                        type={"text"}
                                        activeYn={true}
                                        inputCb={(v)=>{setHostPath(v)}}
                                        warnYn={volumeHostPathWarnYn}
                                        placeHolderText={t("HOST_PATH_ENTER_MESSAGE")}
                                    />
                                </View>
                                : null
                            }
                            {
                                volumeTypeCode === "HOSTPATH"
                                ? <View style={style.rowContainer}>
                                    <CustomText text={t("POD_VOLUME_HOST_PATH_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                    <CustomDropDown
                                        key={49}
                                        width={540} height={36}
                                        items={podVolumeHostPathTypes}
                                        value={hostPathTypeCode}
                                        setValue={(v)=>setHostPathTypeCode(v)}
                                        disable={false}
                                        defaultvalue={podVolumeHostPathTypes[0]}
                                    />
                                </View>
                                : null
                            }
                        </View>
                    :null
                    }
                </View>
            : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    topContainer: {

    },
    listMainContainer: {
        marginTop: 38,
        paddingTop: 20,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        borderRadius: 10,
        borderColor: "#9ea0a5",
        borderWidth: 0.5,
        marginBottom: 20,
    },
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 20
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    AddInfoBox: {
        width: 580, height: 230,
        marginLeft: 150, marginTop: 20, marginBottom: 20,
        paddingLeft: 20, paddingTop: 20, paddingBottom: 20, paddingRight: 40,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
    },
    AddInfoColumnText: {
        width: 130,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    requireText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#e86045"
    },
    infoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    }
});